module.exports = __webpack_public_path__ + "aecdc19dcf337be0da009ab2fdb9ab58.MP3";